import { PAGES } from './translatedPages';
import { LOCALES } from './locales';

const SITE_URL = 'https://loadsmart.com';

const normalize = (path = '') => {
  const clean = path.split('?')[0].split('#')[0];
  return clean.endsWith('/') ? clean : `${clean}/`;
};

// hreflang alternates for a page: the US version (when it has one), every LATAM
// locale, and x-default pointing at the global English LATAM version. Every
// version of the page lists the same set, so the links are reciprocal.
function alternatesFor(page) {
  const { paths, usPath } = page;

  const languageAlternates = Object.keys(paths).map((code) => ({
    hrefLang: LOCALES[code].hreflang,
    href: `${SITE_URL}${paths[code]}`,
  }));

  if (usPath) {
    languageAlternates.unshift({
      hrefLang: LOCALES['en-US'].hreflang,
      href: `${SITE_URL}${usPath}`,
    });
  }

  // x-default is the US version when the page has one: it is the main site.
  const defaultPath = usPath ?? paths['en-LATAM'];
  if (defaultPath) {
    languageAlternates.push({
      hrefLang: 'x-default',
      href: `${SITE_URL}${defaultPath}`,
    });
  }

  return languageAlternates;
}

// og:locale:alternate tags for every other language the page exists in.
function ogLocaleAlternatesFor(page, currentOgLocale) {
  const codes = [...(page.usPath ? ['en-US'] : []), ...Object.keys(page.paths)];
  return [...new Set(codes.map((code) => LOCALES[code].ogLocale))].filter(
    (ogLocale) => ogLocale !== currentOgLocale
  );
}

// Canonical + hreflang alternates for a page/locale, built from pages.json so
// the URLs the switcher links to and the ones search engines see never drift.
export function getLocalizedSeo(id, locale) {
  const page = PAGES.find((p) => p.id === id);

  const ogLocale = LOCALES[locale].ogLocale;

  return {
    canonical: `${SITE_URL}${page.paths[locale]}`,
    languageAlternates: alternatesFor(page),
    ogLocale,
    ogLocaleAlternates: ogLocaleAlternatesFor(page, ogLocale),
  };
}

// hreflang + og:locale:alternate values for a US (root) page that has LATAM
// versions, or null. The US pages live outside the LATAM route files, so _app
// adds the tags.
export function getUsAlternates(path) {
  const clean = normalize(path);
  const page = PAGES.find((p) => p.live && p.usPath === clean);

  return page
    ? {
        languageAlternates: alternatesFor(page),
        ogLocaleAlternates: ogLocaleAlternatesFor(
          page,
          LOCALES['en-US'].ogLocale
        ),
      }
    : null;
}
